import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Suspense as _Suspense, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Checkin_isotipo_White.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"height":"3.5rem","margin":"0 auto","vertical-align":"center"},
  class: "logo-white"
}, null, -1)
const _hoisted_2 = { class: "desktop-navbar" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = { class: "desktop-navbar__content" }
const _hoisted_5 = { style: {"margin":"0 8px"} }
const _hoisted_6 = {
  key: 1,
  class: "desktop-navbar__dropdown"
}
const _hoisted_7 = { style: {"padding":"10px"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "full-width",
  style: {"height":"1px","background-color":"rgba(0, 0, 0, 0.232)"}
}, null, -1)
const _hoisted_9 = { class: "desktop-navbar__dropdown-menu" }

import {
  IonApp,
  IonRouterOutlet,
  IonMenu,
  IonPage,
  IonHeader,
  IonBackButton,
  IonIcon,
  IonContent,
  IonToolbar,
  IonMenuButton,
  IonTitle,
  IonButtons,
  useIonRouter,
} from "@ionic/vue";
import { personCircle, caretDownOutline } from "ionicons/icons";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";
import { computed, reactive } from "vue";
import axios from "axios";
import Hamburger from "@/views/_partials/Hamburger.vue";
import { useContextStore } from "@/stores/context";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userStore = useUserStore();
const router = useIonRouter();
const route = useRoute();
const contextStore = useContextStore();

const { isMobile } = useWindowWidth();
const userIsOnboarding = computed(() => route.fullPath.includes("/onboarding"));

const userIsHomePageEvent = computed(() => route.fullPath.includes("/home"));
const userIsInEventPages = computed(() => route.fullPath.includes("/event") || route.fullPath.includes("/my-account"));
const userIsInManagementPages = computed(() => route.fullPath.includes("/my-account") || route.fullPath.includes("/manage-events"));
const userIsHomePage = computed(() => route.fullPath === "/home");

const state = reactive({
  profileDropdown: false,
});

const navigate = (endpoint: string) => {
  window.location.href = endpoint;
};

const toggleProfileDropdown = () => {
  state.profileDropdown = !state.profileDropdown;
};

userStore.localLogin();

if (userStore.userIsLoggedIn) {
  userStore
    .fetchMe()
    .then(() => {
      userStore.fetchRoles();
      if (route.fullPath.includes("onboarding/introduction")) {
        router.push("/home");
      }
    })
    .catch(() => {
      userStore.setUserLogout();
      router.push("/login");
    });
}

const logout = () => {
  state.profileDropdown = false;
  userStore.setUserLogout();
  router.push("/login");
};

axios.interceptors.response.use(undefined, (err) => {
  const serverPath = process.env.VUE_APP_SERVER_PATH;

  if (err.request.responseURL.includes(serverPath)) {
    if (err.request.status === 401) {
      // if you ever get an unauthorized, logout the user
      // userStore.setUserLogout();
      // userLoaded.value = true;
      // router.push("/login");
    }
    if (err.request.status === 403) {
      // User should not see permissions error
    } else if (err.request.status === 429) {
      // User throttled
    } else if ([500].includes(err.request.status)) {
      // Backend boom
    }
  }
  throw err;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonMenu), { "content-id": "root-main-content" }, {
        default: _withCtx(() => [
          _createVNode(Hamburger)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonPage), { id: "root-main-content" }, {
        default: _withCtx(() => [
          (_unref(userStore).userIsLoggedIn && !userIsOnboarding.value)
            ? (_openBlock(), _createBlock(_unref(IonHeader), { key: 0 }, {
                default: _withCtx(() => [
                  (_unref(isMobile))
                    ? (_openBlock(), _createBlock(_unref(IonToolbar), { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButtons), { slot: "start" }, {
                            default: _withCtx(() => [
                              ((userIsInManagementPages.value || userIsInEventPages.value) && !userIsHomePageEvent.value)
                                ? (_openBlock(), _createBlock(_unref(IonBackButton), {
                                    key: 0,
                                    color: "white",
                                    "default-href": `/event/${_unref(contextStore).event.id}/home`
                                  }, null, 8, ["default-href"]))
                                : _createCommentVNode("", true),
                              (userIsHomePageEvent.value)
                                ? (_openBlock(), _createBlock(_unref(IonBackButton), {
                                    key: 1,
                                    color: "white",
                                    "default-href": `/home`,
                                    style: _normalizeStyle(userIsHomePage.value ? { visibility: 'hidden' } : {})
                                  }, null, 8, ["style"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonTitle), null, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonButtons), { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonMenuButton), { color: "white" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_unref(IonToolbar), { key: 1 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(IonTitle), null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _createElementVNode("img", {
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate('/home'))),
                                    src: _imports_0,
                                    alt: "",
                                    style: {"height":"3.5rem"},
                                    class: "logo-white clickable"
                                  }),
                                  _createElementVNode("ul", _hoisted_4, [
                                    _createElementVNode("li", {
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (navigate('/home')))
                                    }, "Home"),
                                    _createElementVNode("li", {
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (navigate('/onboarding/new-event')))
                                    }, " Create event "),
                                    _createElementVNode("li", {
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (navigate('/manage-events')))
                                    }, "Manage events"),
                                    _createElementVNode("li", {
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (
                      navigate(
                        'https://beamian-kb.atlassian.net/servicedesk/customer/portal/9'
                      )
                    ))
                                    }, " Help center "),
                                    _createElementVNode("li", {
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (navigate('https://beamian.com/lp-about-beamian/')))
                                    }, " About us "),
                                    _createElementVNode("li", {
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (
                      navigate(
                        'https://beamian.com/lp-need-more-than-check-in/'
                      )
                    ))
                                    }, " Need more? ")
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonButtons), {
                              class: "desktop-navbar__profile",
                              slot: "end",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleProfileDropdown()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  icon: _unref(personCircle),
                                  size: "large"
                                }, null, 8, ["icon"]),
                                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(userStore).me.name), 1),
                                _createVNode(_unref(IonIcon), { icon: _unref(caretDownOutline) }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonContent), null, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_Suspense, null, {
                fallback: _withCtx(() => [
                  _createTextVNode(" Loading... ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(IonRouterOutlet), { animated: _unref(isMobile) }, null, 8, ["animated"])
                ]),
                _: 1
              }))
            ]),
            _: 1
          }),
          (!_unref(isMobile) && state.profileDropdown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(userStore).me.name), 1),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (navigate('/my-account')))
                  }, "My account"),
                  _createElementVNode("div", {
                    style: {"color":"rgb(185, 5, 5)"},
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (logout()))
                  }, "Logout")
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})